import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { messageMapper, useLlm, useLlmView } from '@websolutespa/bom-mixer-llm';
import { motion } from 'framer-motion';
import style from './trigger.module.scss';

export const Trigger: React.FC = () => {
  const theme = useLlm(state => state.theme);
  const app = useLlm(state => state.app);
  const opened = useLlmView(state => state.opened);
  const { open } = useLlmView(state => state.actions);
  const label = useLabel();
  const collapsedWelcomeText = messageMapper(app?.contents.collapsedWelcomeText);
  const collapsedWelcomeTextCta = messageMapper(app?.contents.collapsedWelcomeTextCta);
  const collapsedWelcomeTextHover = messageMapper(app?.contents.collapsedWelcomeTextHover);
  const position = theme.trigger?.position || 'bottom';
  return (
    <motion.nav
      className={getClassNames(style.trigger, style[position])}
      initial={{ y: '200%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '200%', opacity: 0 }}
      transition={{ duration: .4 }}
      aria-label="Trigger"
      onClick={() => open()}
    >
      <button className={getClassNames(style.button, {
        [style.buttonHover]: collapsedWelcomeTextHover !== undefined,
      })} type="button">
        <div className={style.buttonIcon}>
          <svg width="51" height="53" viewBox="0 0 51 53" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48.45 0c.676 0 1.325.286 1.803.796S51 1.997 51 2.718V53l-11.36-9.513H2.55a2.47 2.47 0 0 1-1.803-.796A2.8 2.8 0 0 1 0 40.77V2.718C0 1.997.269 1.306.747.796A2.47 2.47 0 0 1 2.55 0z" fill="#000" /><path d="M16.414 26.05H10.59v2.373h4.531v1.941H10.59v2.698h5.825v2.157H8V24h8.414zm10.68 0h-5.393v2.805H25.8v1.94h-4.207v4.424h-2.59V24h8.092zM36.373 24c1.079 0 1.726.215 2.05.54.324.323.54.647.647 1.078.108.432.215 1.187.215 2.05h-2.48c0-.755-.109-1.295-.325-1.51-.108-.108-.323-.108-.754-.108h-2.158c-.43 0-.647 0-.755.107-.215.216-.431 1.403-.431 3.452s.108 3.129.431 3.453c.108.107.324.108.755.108h2.158c.323 0 .646 0 .755-.108q.323-.324.324-1.619v-.323H34.43v-1.942h5.07v1.402c0 1.187-.108 2.158-.216 2.697-.216.648-.431 1.08-.755 1.403-.431.323-1.079.539-2.05.539h-3.56c-.97 0-1.617-.216-2.049-.54-.323-.323-.647-.862-.863-1.617-.216-.756-.323-1.835-.323-3.453s.107-2.805.323-3.452c.216-.755.432-1.294.863-1.618.432-.431 1.08-.539 2.05-.539zm-6.858-9.458a1.62 1.62 0 0 0 1.021 1.021l.85.283-.85.283a1.62 1.62 0 0 0-1.021 1.021l-.284.85-.282-.85a1.62 1.62 0 0 0-1.022-1.021l-.849-.283.849-.283a1.62 1.62 0 0 0 1.022-1.021l.282-.85zM24.43 8.197a3.23 3.23 0 0 0 2.218 2.219l2.044.584-2.043.584a3.23 3.23 0 0 0-2.218 2.218h-.001l-.584 2.044-.583-2.043a3.23 3.23 0 0 0-2.22-2.219L19 11l2.043-.584a3.23 3.23 0 0 0 2.219-2.218l.584-2.044zm6.063-3.454a2.42 2.42 0 0 0 1.764 1.764l.743.185-.743.186a2.42 2.42 0 0 0-1.764 1.764l-.185.743-.186-.743a2.43 2.43 0 0 0-1.763-1.764l-.744-.186.744-.185a2.42 2.42 0 0 0 1.763-1.764L30.308 4z" fill="#fff" /></svg>
        </div>
        <span className={style.buttonLabel}>{label('llm.button')}</span>
      </button>
      {!opened && (collapsedWelcomeText || collapsedWelcomeTextCta || collapsedWelcomeTextHover) && (
        <div className={style.popup}>
          {(collapsedWelcomeText || collapsedWelcomeTextCta) && (
            <motion.div
              className={style.popupMessage}
              exit={{
                opacity: 0,
              }}>
              {collapsedWelcomeText}
              {collapsedWelcomeTextCta && (
                <button type="button" className={style.popupCta}>{collapsedWelcomeTextCta}</button>
              )}
            </motion.div>
          )}
          {collapsedWelcomeTextHover && (
            <motion.div
              className={style.popupMessage}
              exit={{
                opacity: 0,
              }}>
              {collapsedWelcomeTextHover}
            </motion.div>
          )}
        </div>
      )}
    </motion.nav>
  );
};

